<template>
  <div class="invoice-links container">
    <a
      href="/invoices"
      :class="['invoice-link', { active: $route.name === 'Invoices' }]"
      >General Invoices</a
    >
    <a
      href="/invoices/off-course"
      :class="[
        'invoice-link',
        { active: $route.name === 'Off-Course Invoices' },
      ]"
      >Off-Course Invoices</a
    >
  </div>
</template>
<style scoped>
.invoice-links {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  /* margin-bottom: 1rem; */
}

.invoice-link {
  background-color: #4caf50;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  text-decoration: none;
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.invoice-link:hover {
  background-color: #75a045;
}
.active {
  background-color: #75a045;
  color: white;
}
</style>
